/** Cache keys of decks and their cards. */
export const deckKeys = {
  all: ['decks'] as const,
  one: (deckId: string) => ['decks', deckId] as const,
  cards: (deckId: string) => ['decks', deckId, 'cards'] as const,
};

/** Cache key prefix of review queues; invalidated whenever cards change. */
export const reviewQueueKey = ['review-queue'] as const;
